import React from "react";
import { Field } from "formik";
import { Grid, SearchSelect } from "../../../.."; // import PropTypes from 'prop-types';

import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      padding: "20px",
      "min-height": "48vh"
    },
    // flex: {
    // 	display: 'flex',
    // 	'flex-direction': 'column',
    // 	'justify-content': 'space-between'
    // },
    mr30: {
      "margin-right": "30px",
      width: "50%"
    },
    w25: {
      width: "25%"
    },
    currency: {
      width: "220px"
    },
    estimatedValue: {
      display: "flex",
      "flex-direction": "row",
      "align-items": "center",
      height: "auto"
    },
    dates: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "start"
    }
  };
});

var TemplateProjectForm = function TemplateProjectForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      templates = _ref.templates,
      label = _ref.label;
  var classes = useStyles(); // console.log("TemplateProjectForm values", values);

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "template",
    label: label,
    className: classes.mr30,
    component: SearchSelect,
    placeholder: "Escribe para buscar...",
    margin: "normal",
    value: values.template,
    options: templates,
    clickable: mode !== "view"
  })));
}; // OpportunityForm.propTypes = {
// 	/** Values coming from Formik*/
// 	values: PropTypes.object,
// 	/** Mode to be render. If 'add' content can be added, if 'edit', previous content would be loaded and can be edited, if 'view' no edit option is allowed */
// 	mode: PropTypes.oneOf([ 'edit', 'view', 'add' ])
// };
// OpportunityForm.defaultProps = {
// 	mode: 'add'
// };


export { TemplateProjectForm };